import { produce } from 'immer';
import { createReducer } from 'typesafe-actions';

import { replaceByUuid } from '@portal/common/dist/utils/store-utils';

import {
  createFeatureFlagAction,
  deleteFeatureFlagAction,
  disableFeatureFlagAction,
  enableFeatureFlagAction,
  getAllFeatureFlagsAction,
  toggleCreate,
  updateFeatureFlagAction,
} from './actions';
import type { FeatureFlagAction, FeatureFlagState } from './types';

export const featureFlagInitialState: FeatureFlagState = {
  createDrawerVisible: false,
  rows: [],
};

export const featureFlagReducer = createReducer<
  FeatureFlagState,
  FeatureFlagAction
>(featureFlagInitialState)
  .handleAction(
    getAllFeatureFlagsAction.success,
    (state, { payload: featureFlags }) =>
      produce(state, (draftState) => {
        draftState.rows = featureFlags;
      })
  )
  .handleAction(
    createFeatureFlagAction.success,
    (state, { payload: featureFlag }) =>
      produce(state, (draftState) => {
        draftState.rows = [...draftState.rows, featureFlag];
      })
  )
  .handleAction(
    [
      enableFeatureFlagAction.success,
      disableFeatureFlagAction.success,
      updateFeatureFlagAction.success,
    ],
    (state, { payload: featureFlag }) =>
      produce(state, (draftState) => {
        draftState.rows = replaceByUuid(draftState.rows, [featureFlag]);
      })
  )
  .handleAction(deleteFeatureFlagAction.success, (state, { payload: resp }) =>
    produce(state, (draftState) => {
      draftState.rows = draftState.rows.filter((row) => row.uuid !== resp.uuid);
    })
  )
  .handleAction(toggleCreate, (state) =>
    produce(state, (draftState) => {
      draftState.createDrawerVisible = !draftState.createDrawerVisible;
    })
  );
